angular.module('lf.common')

.directive('parseOptionsToProp', function () {
  return {
    restrict: 'A',
    priority: 2, // run before ng-model (priority: 1)
    require: 'select',
    scope: { 'prop': '=parseOptionsToProp' },
    compile: function (el) {
      var options = el.find('option').toArray().map(function (option) {
        return {
          value: option.value,
          text: option.textContent
        }
      });

      var $emptyOption = el.find('option:eq(0)[value=""]');
      
      el.empty();

      if ($emptyOption.length) {
        options.splice(0, 1);
        el.append($emptyOption);
      } else {
        el.append('<option value=""></option>');
      }

      return {
        pre: function preLink (scope) {
          scope.prop = options;
        }
      }
    }
  }
});
